import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useLang } from "../LanguageContext";
import { Reveal, Overline, LineReveal } from "./Reveal";
import { optImg } from "../lib/img";

const Intro = () => {
  const { t, images } = useLang();
  const IMAGES = images;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section className="bg-paper py-24 md:py-36 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-14 md:gap-20 items-center">
        <div>
          <Reveal><Overline>{t.intro.overline}</Overline></Reveal>
          <h2 className="font-serif text-ink font-light leading-[1.05] text-4xl md:text-6xl mt-7">
            <LineReveal>{t.intro.title}</LineReveal>
          </h2>
          <Reveal delay={0.15}>
            <p className="mt-8 text-ink/65 text-lg font-light leading-relaxed max-w-lg">{t.intro.body}</p>
          </Reveal>
        </div>

        <div ref={ref} className="relative aspect-[4/5] md:aspect-[3/4] overflow-hidden">
          <motion.img style={{ y: imgY }} src={optImg(IMAGES.workshop, 1000)} alt="" loading="lazy" decoding="async" className="absolute inset-0 h-[116%] w-full object-cover" />
          <div className="absolute inset-0 ring-1 ring-inset ring-black/10" />
          <div className="absolute -bottom-px -left-px w-24 h-24 border-l border-b border-gold" />
          <div className="absolute -top-px -right-px w-24 h-24 border-r border-t border-gold" />
        </div>
      </div>
    </section>
  );
};

export default Intro;
